import { Validators } from '@angular/forms';
import { config } from '../_models/config';

export const ENVIRONMENT = {
    MASTER: 'master',
    BETA: 'beta',
    STAGING: 'stg',
    QA: 'qa',
    PREVIEW: 'preview',
    PROPERTIES: config,
    MOCK: false,
    OUTPUT: false,
}

export const regexPatterns = {
    NAME: /^[a-zA-Z][a-zA-Z'.\- ]*$/,
    PHONE_NUMBER_US: /^[2-9]\d{2}\s-\s\d{3}\s-\s\d{4}$/,
    GATE_NUMBER: /^[a-zA-Z0-9]*$/,
    AIRPORT_CODE: /^[a-zA-Z]*$/,
    CONFIRMATION_NUMBER: /^[A-Z0-9]{6}$/,
    DESTINATION: /^[a-zA-Z][a-zA-ZÀ-ž'.\- \/\(\)]*$/,
    PHONE_NUMBER: /^\d{7,15}$/,
    DAY: /^([1-9]|3[01]|[12]\d|[0][1-9])$/,
    YEAR: /^(19[0-9]\d|20[0-2]\d)$/,
    EMAIL: /^[\w+.-]+@[\w-]+(\.\w{2,})+$/
};

const nameMaxLength = 35;

enum ERROR_CODES {
    TIMEOUT_ERROR = 408,
    AUTH_ERROR = 403,
    SERVER_ERROR = 500,
    REQUEST_ERROR = 400,
}
export const API_ERROR_CODES = [ERROR_CODES.AUTH_ERROR, ERROR_CODES.SERVER_ERROR, ERROR_CODES.TIMEOUT_ERROR];

export const PARAMS = {
    AIRPORT: 'a',
    GATE: 'g',
    ROUTING_CODE: 'rc',
    REGION: 'r',
    ASSET_ID: 'aid',
    STATION_ID: 'sid',
    PNR: 'pnr',
    LAST_NAME: 'ln',
    UA_SOURCE: 'ua_source',
    ENCRYPTED_STRING: 'p',
    ENCRYPT_STRING: 'es',
    REASON: 'reason',
};

export const ROUTING_CODES = {
    DOC: {
        CODE: 'DOC',
        ROUTE: '/doc-check'
    },
    PRE_CHAT: {
        ROUTE: '/pre-chat',
        NAME: 'PRE CHAT'
    },
    HELP_OPTIONS: {
        ROUTE: '/help-options',
        NAME: 'Help options'
    },
    SELF_SERVICE: {
        ROUTE: '/self-service',
        NAME: 'Self Service'
    },
    ADD_INFO: {
        ROUTE: "/additional-info",
        NAME: 'Additional info'
    },
    TRAVELER_SELECTION: {
        ROUTE: '/select-traveler',
        NAME: 'Traveler Selection'
    },
    WELCOME: {
        ROUTE: '/welcome',
        NAME: 'Welcome'
    },
    FLIGHT_REBOOK: {
        CODE: 'RB',
        ROUTE: '/flight-rebook',
        NAME: 'Flight Rebook'
    },
};

export enum CONNECTION_TYPES {
    VIDEO = "video",
    AUDIO = "audio",
    TEXT = "text"
};

export enum LANGUAGE {
    ENGLISH = 'en',
    FRENCH = 'fr',
    GERMAN = 'de',
    SPANISH = 'es',
    CHINESE = 'zh',
    PORTUGUESE = 'pt',
    JAPANESE = 'ja',
    //HEBREW = 'he',
    ITALIAN = 'it',

}
enum LANG_DIRECTIONS {
    LEFT_RIGHT = 'ltr',
    RIGHT_LEFT = 'rtl'
}

export const LANGUAGES_SUPPORTED = {
    [LANGUAGE.ENGLISH]: { key: 'English', value: 'English', locale: 'en', fallback: "English", direction: LANG_DIRECTIONS.LEFT_RIGHT },
    [LANGUAGE.SPANISH]: { key: 'Spanish', value: 'Español', locale: 'es', fallback: "inglés", direction: LANG_DIRECTIONS.LEFT_RIGHT },
    [LANGUAGE.GERMAN]: { key: 'German', value: 'Deutsche', locale: 'de', fallback: "Englisch", direction: LANG_DIRECTIONS.LEFT_RIGHT },
    [LANGUAGE.FRENCH]: { key: 'French', value: 'Français', locale: 'fr', fallback: "l'anglais", direction: LANG_DIRECTIONS.LEFT_RIGHT },
    [LANGUAGE.CHINESE]: { key: 'Chinese_smpl', value: '汉语', locale: 'zh', fallback: "英语", direction: LANG_DIRECTIONS.LEFT_RIGHT },
    [LANGUAGE.PORTUGUESE]: { key: 'Portuguese', value: 'Português', locale: 'pt', fallback: "inglês", direction: LANG_DIRECTIONS.LEFT_RIGHT },
    [LANGUAGE.JAPANESE]: { key: 'Japanese', value: '日本語', locale: 'ja', fallback: "英語", direction: LANG_DIRECTIONS.LEFT_RIGHT },
    //[LANGUAGE.HEBREW]: { key: 'Hebrew', value: 'עִברִית', locale: 'he', fallback: "אנגלית", direction: LANG_DIRECTIONS.RIGHT_LEFT },
    [LANGUAGE.ITALIAN]: { key: 'Italian', value: 'Italiano', locale: 'it', fallback: "inglese", direction: LANG_DIRECTIONS.LEFT_RIGHT },
}

export const LANGUAGE_KEYS = {
    ALERT_MSG_COMPONENT: {
        CHECKED_IN: 'flightOptionsConfirmationCheckedInAlertMsgTitle',
        SENT_BOARDING_PASS: 'flightOptionsConfirmationSentBordingPassAlertMsgTitle',
        ERROR_SELECTED_FLIGHT_TITLE: 'flightOptionsConfirmationFlightErrorTitle',
        ERROR_SELECTED_FLIGHT_MESSAGE: 'flightOptionsConfirmationFlightError',
        ERROR_SEARCH_FLIGHT_TITLE: 'flightOptionsConfirmationFlightSearchErrorTitleCopy',
        ERROR_SEARCH_FLIGHT_MESSAGE_SAME_PAGE: 'flightOptionsConfirmationFlightSearchErrorSamePage',
        ERROR_SEARCH_FLIGHT_MESSAGE_BACK_PAGE: 'flightOptionsConfirmationFlightSearchErrorBackPage',
        CHECK_IN_UNAVAILABLE_TITLE: "flightOptionsConfirmationNoCheckInTitle",
        CHECK_IN_UNAVAILABLE_MESSAGE: "flightOptionsConfirmationNoCheckInText"
    },
    FLIGHT_CARD_CONTAINER: {
        TITLE: 'flightInfo'
    }
}

/*
    [LANGUAGE.GERMAN]: { key: 'German', value: 'Deutsche', locale: 'de', fallback: "Englisch" },
    [LANGUAGE.FRENCH]: { key: 'French', value: 'Français', locale: 'fr, fallback: "l'anglais" },
    [LANGUAGE.CHINESE]: { key: 'Chinese', value: '汉语', locale: 'zh', fallback: "English" },
 */

export enum HELP_OPTION_CODES {
    BOARDING_PASS = "boarding-pass",
    SEND_BOARDING_PASS = "send-boarding-pass",
    FLIGHT_CHANGE = "flight-change",
    SEAT_CHANGE = "seat-change",
    DOC_CHECK = "doc-check",
    HAWAII_DOC_CHECK = "hawaii-doc-check",
    FLIGHT_REBOOK = "flight-rebook",
    BAGGAGE = "baggage",
    OTHER = "other",
    PRE_CLEARANCE = "pre-clearance",
    BOARDING_PASS_UNSTYLED = "boarding-pass-unstyled",
    DOC_CHECK_STYLED = 'doc-check-styled',
    ARRANGE_DELIVERY = 'arrange-for-delivery'

}


export const HELP_OPTIONS_ = {
    [HELP_OPTION_CODES.DOC_CHECK]: {
        label: "verifyTravelDocs",
        value: HELP_OPTION_CODES.DOC_CHECK,
        icon: "doc-check.svg",
    },
    [HELP_OPTION_CODES.DOC_CHECK_STYLED]: {
        label: "verifyTravelDocs",
        value: HELP_OPTION_CODES.DOC_CHECK,
        icon: "doc-check-white.svg",
        styleClass: 'primary'
    },
    [HELP_OPTION_CODES.SEAT_CHANGE]: {
        label: "seatChange",
        value: HELP_OPTION_CODES.SEAT_CHANGE,
        icon: "seat.svg",
    },
    [HELP_OPTION_CODES.FLIGHT_CHANGE]: {
        label: "flightChange",
        value: HELP_OPTION_CODES.FLIGHT_CHANGE,
        icon: "flight-icon.svg",
    },
    [HELP_OPTION_CODES.BAGGAGE]: {
        label: "bag",
        value: HELP_OPTION_CODES.BAGGAGE,
        icon: "baggage.png",
    },
    [HELP_OPTION_CODES.BOARDING_PASS]: {
        label: "boardingPass",
        value: HELP_OPTION_CODES.BOARDING_PASS,
        icon: "boarding-pass-white.svg",
        styleClass: 'primary'
    },
    [HELP_OPTION_CODES.SEND_BOARDING_PASS]: {
        label: "sendBoardingPass",
        value: HELP_OPTION_CODES.SEND_BOARDING_PASS,
        icon: "boarding-pass-white.svg",
        styleClass: 'primary'
    },
    [HELP_OPTION_CODES.HAWAII_DOC_CHECK]: {
        label: "hawaiiPreClearance",
        value: HELP_OPTION_CODES.DOC_CHECK,
        icon: "vacation-white.svg",
        styleClass: 'primary'
    },
    [HELP_OPTION_CODES.FLIGHT_REBOOK]: {
        label: "rebook",
        value: HELP_OPTION_CODES.FLIGHT_REBOOK,
        icon: "rebook.svg",
        styleClass: 'primary'
    },
    [HELP_OPTION_CODES.BOARDING_PASS_UNSTYLED]: {
        label: "boardingPass",
        value: HELP_OPTION_CODES.BOARDING_PASS,
        icon: "boarding-pass.svg",
    },
    [HELP_OPTION_CODES.OTHER]: {
        display: true,
        label: "other",
        value: HELP_OPTION_CODES.OTHER,
    },
    [HELP_OPTION_CODES.ARRANGE_DELIVERY]: {
        label: 'arrangeDelivery',
        value: HELP_OPTION_CODES.ARRANGE_DELIVERY,
        icon: "baggage.png"
    }
}

export const PRE_CHAT_REASONS_ = {
    [HELP_OPTION_CODES.FLIGHT_CHANGE]: {
        label: "flightChange",
        value: HELP_OPTION_CODES.FLIGHT_CHANGE
    },
    [HELP_OPTION_CODES.SEAT_CHANGE]: {
        label: "seatChange",
        value: HELP_OPTION_CODES.SEAT_CHANGE
    },
    [HELP_OPTION_CODES.DOC_CHECK]: {
        label: "verifyTravelDocs",
        value: HELP_OPTION_CODES.DOC_CHECK
    },
    [HELP_OPTION_CODES.DOC_CHECK_STYLED]: {
        label: "verifyTravelDocs",
        value: HELP_OPTION_CODES.DOC_CHECK
    },
    [HELP_OPTION_CODES.BAGGAGE]: {
        label: "baggage",
        value: HELP_OPTION_CODES.BAGGAGE,
    },
    [HELP_OPTION_CODES.OTHER]: {
        label: "somethingElse",
        value: HELP_OPTION_CODES.OTHER
    },
    [HELP_OPTION_CODES.HAWAII_DOC_CHECK]: {
        label: "hawaiiPreClearance",
        value: HELP_OPTION_CODES.HAWAII_DOC_CHECK
    }
}

export const HELP_OPTIONS = {
    TITLE: "formTitle",
    SECONDARY: {
        display: true,
        label: "other",
        value: HELP_OPTION_CODES.OTHER,
    },
    ERROR_MESSAGES: {
        BOARDING_PASS: "boardingPassError"
    },
    SUCCESS_MESSAGES: {
        SENT_BOARDING_PASS: "smsSent"
    }
}

export const USER_INFO_FORM = {
    MESSAGES: {
        NON_PNR_FLOW: {
            title: 'title',
            info: 'chatInfo'
        },
        PNR_FLOW: {
            title: 'pageHeader',
            info: ''
        }
    },
    CONTROLS: {
        LAST_NAME: {
            label: 'lastNameLabel',
            isRequired: true,
            placeholder: 'Please enter your last name',
            required: "lastNameRequired",
            maxLength: nameMaxLength,
            validators: [
                Validators.required,
                Validators.pattern(regexPatterns.NAME),
            ],
            errors: {
                invalid: "invalidLastName"
            }

        },
        FIRST_NAME: {
            label: 'firstNameLabel',
            isRequired: true,
            placeholder: 'Please enter your first name',
            required: "firstNameRequired",
            maxLength: nameMaxLength,
            validators: [
                Validators.required,
                Validators.pattern(regexPatterns.NAME),
            ],
            errors: {
                invalid: "invalidFirstName"
            }
        },
        SMS_CONSENT: {
            label: 'smsConsentLabel',
            consentText: 'smsConsentText',
            smsTerms: 'smsTerms'
        },
        PHONE: {
            label: 'phoneLabel',
            isRequired: true,
            validators: [Validators.required],
            controls: {
                CODE: {
                    isRequired: true,
                    placeholder: 'countryCodePlaceHolder',
                    validators: [Validators.required],
                    options: []
                },
                NUMBER: {
                    isRequired: true,
                    placeholder: 'XXX - XXX - XXXX',
                    validators: {
                        default: [Validators.required],
                        others: [
                            Validators.required,
                            Validators.pattern(regexPatterns.PHONE_NUMBER)
                        ]
                    },
                    maskOptions: {
                        mask: [/[2-9]/, /\d/, /\d/, ' ', '-', ' ', /\d/, /\d/, /\d/, ' ', '-', ' ', /\d/, /\d/, /\d/, /\d/],
                        guide: false
                    },
                    errors: {
                        required: 'phoneRequired',
                        invalid: 'invalidPhone'
                    }
                },
            }
        },
        CONNECTION_TYPE: {
            label: 'connectionType',
            isRequired: true,
            validators: [Validators.required],
            options: [
                {
                    label: 'audioLabel',
                    value: CONNECTION_TYPES.AUDIO,
                    icon: 'phone-call.svg'
                },
                {
                    label: 'videoLabel',
                    value: CONNECTION_TYPES.VIDEO,
                    icon: 'video-call.svg'
                },
                {
                    label: 'chatLabel',
                    value: CONNECTION_TYPES.TEXT,
                    icon: 'text.svg'
                }
            ]
        },
        LANGUAGE_PREFERENCE: {
            title: "Preferred language",
            label: "Langauge options",
            validators: [Validators.required],
            options: Object.values(LANGUAGES_SUPPORTED),
        },
        REASON: {
            label: "reasonLabel",
            isRequired: false,
            options: [],
            placeholder: "Select option"
        }
    }
};

export const GATE_CONSTANTS = {
    GEN: 'GEN',
    BAG: 'BAG',
    HAWAII: 'HAWAII',
    VIP: 'VIP',
    TRAIN: 'TRAIN',
    Z200: 'Z200',
    TEST: 'TEST'
}

enum REBOOK_FLOW_PAGES {
    SEARCH_FORM = 'FLIGHT_SEARCH_DATE',
    FLIGHT_OPTIONS = 'FLIGHT_OPTIONS',
    FLIGHT_CONFIRMATION = 'FLIGHT_CONFIRMATION'
}

export const REBOOK_FLOW_CUSTOM_REASONS = {
    REBOOK: {
        [REBOOK_FLOW_PAGES.SEARCH_FORM]: 'Flight-rebook-SS-datepage',
        [REBOOK_FLOW_PAGES.FLIGHT_OPTIONS]: 'Flight-rebook-SS-optionspage',
        [REBOOK_FLOW_PAGES.FLIGHT_CONFIRMATION]: 'Flight-rebook-SS-confirmationpage'
    },
    CHANGE: {
        [REBOOK_FLOW_PAGES.SEARCH_FORM]: 'Flight-change-SS-datepage',
        [REBOOK_FLOW_PAGES.FLIGHT_OPTIONS]: 'Flight-change-SS-optionspage',
        [REBOOK_FLOW_PAGES.FLIGHT_CONFIRMATION]: 'Flight-change-SS-confirmationpage'
    }
}

export enum REGIONS_SUPPORTED {
    AFRICA = 'africa',
    EUROPE = "europe",
    LATIN_SOUTH_AMERICA = "latinSouthAmerica",
    US_INBOUND = "us-inbound",
    OTHER = "other",
    COMBINED = "combined",
}

export const DOC_CHECK_FORM = {
    MESSAGES: {
        TITLE: "destination",
        INFO: 'formHeader'
    },
    CONTROLS: {
        SELECTED_REGION: {
            isRequired: true,
            validators: [Validators.required],
            options: [
                {
                    label: 'africa',
                    alpha3Code: 'AF',
                    value: 'africa'
                },
                {
                    label: 'europe',
                    alpha3Code: 'EU',
                    value: 'europe'
                },
                {
                    label: 'latinSouthAmerica',
                    alpha3Code: 'SA',
                    value: 'latinsouthamerica'
                },
                {
                    label: 'usInBound',
                    alpha3Code: 'USA',
                    value: 'us-inbound'
                },
                {
                    label: 'other',
                    alpha3Code: 'O',
                    value: 'other'
                }
            ]
        }
    }
};

export enum ChatProviders {
    WEBEX = 'webex'
}

export enum ChatEvents {
    DATA_UPDATE = "myself_data_updated",
    UI_RELOADED = "ui_reloaded",
    PLEASE_THREAD_READY_MANAGER = "please-thread_manager_ready",
    IS_FEEDBACK_SUBMITTED = "is-feedback-submitted",
    DISPOSE = "dispose",
    DESTROY = "destroy",
    SUBMIT = "submit",
    DISCONNECT = "disconnect",
    STATUS = "status",
    CONNECT = "connect",
    THREAD_MESSAGE_LOADED = "thread_message_loaded",
    ADD_MESSAGE = "addMessage",
    READY = "ready",
    START = "start",
    STOP = "stop",
    NEW_THREAD_CLICKED = "new-thread-clicked",
    CONVERSATION_START = "conversation-start",
    CONVERSATION_END = "conversation-end",
    CONVERSATION_TIMED_OUT = "conversation-timed-out",
    AGENT_JOINED_CHAT = "agent_joined_chat",
    TRANSFER_END = "call-ended"
}


export enum QuantumMetricEvents {
    CONVERSION_STARTED = 54,
    CONVERSATION_ENDED = 60,
    CUSTOMER_EXITED = 62,
    CUSTOMER_TIMED_OUT = 63,
    FEEDBACK_SUBMITTED = 61,
    SCANNER_TIMEOUT = 75,
    SCANNER_ERROR = 76,
    SCANNER_SUCCESS = 77,
    SCRIPT_ERROR = 148,
    AGENT_JOINED_CHAT = 198,
    FLIGHT_REBOOK_CAN_CHANGE_FLIGHT = 192,
    FLIGHT_REBOOK_CAN_REBOOK_FLIGHT = 211,
    SENT_BOARDINGPASS_VIA_EMAIL = 203,
    SENT_BOARDINGPASS_VIA_SMS = 202,
    SENT_TO_INNER_QUEUE = 209,
    SENT_TO_OUTER_QUEUE = 210,
}

export const DDActions = {
    54: 'CONVERSION_STARTED',
    60: 'CONVERSATION_ENDED',
    62: 'CUSTOMER_EXITED',
    63: 'CUSTOMER_TIMED_OUT',
    61: 'FEEDBACK_SUBMITTED',
    75: 'SCANNER_TIMEOUT',
    76: 'SCANNER_ERROR',
    77: 'SCANNER_SUCCESS',
    148: 'SCRIPT_ERROR',
    198: 'AGENT_JOINED_CHAT',
    192: 'FLIGHT_REBOOK_CAN_CHANGE_FLIGHT',
    211: 'FLIGHT_REBOOK_CAN_REBOOK_FLIGHT',
    203: 'SENT_BOARDINGPASS_VIA_EMAIL',
    202: 'SENT_BOARDINGPASS_VIA_SMS',
    209: 'SENT_TO_INNER_QUEUE',
    210: 'SENT_TO_OUTER_QUEUE',
    HELP_OPTION_SELECTED: 'HELP_OPTION_SELECTED',
    API_REQUEST: 'API_REQUEST',
    API_RESPONSE: 'API_RESPONSE',
    FLIGHT_REBOOKED: 'FLIGHT_REBOOKED',
    FLIGHT_CHANGED: 'FLIGHT_CHANGED',
    TRH_NAVIGATION: 'TRH_NAVIGATION'
}

export const ROUTED_DEPARTMENT = {
    GENERAL: 'general',
    GENERAL_ONLY: 'general only',
    SPANISH: 'spanish',
    SPANISH_ONLY: 'spanish only',
    PREMIER: 'premier',
    PREMIER_ONLY: 'premier only',
}

export const STORAGE_KEYS = {
    USER_DETAILS: 'userDetails',
    PARAMS: 'params',
    CUSTOM_FIELDS: 'customFields',
    PNR_DETAILS: 'pnrDetails',
    AUTH: 'auth',
    COOKIE_CONSENT: 'cookieConsent',
    LANGUAGE: 'languagePreferred',
    CHAT_EVENTS: 'chatEvents',
}

export const FLIGHT_LOOKUP_FORM = {
    MESSAGES: {
        TITLE: "title",
        INFO: "info",
        INFO_NO_SCAN: 'infoNoScanner',
        ERROR: "pnrSearchError",
        SCAN_ERROR: "scannerError",
        SCAN_TIMEOUT: "scannerTimeOut",
        LINK_TEXT: "linkText",
        SCAN_LINK_TEXT: "scannerLinkText"
    },
    CONTROLS: {
        LAST_NAME: {
            label: 'lastName',
            isRequired: true,
            placeholder: "Please enter your last name",
            required: 'lastNameRequired',

            maxLength: nameMaxLength,
            validators: [
                Validators.required,
                Validators.pattern(regexPatterns.NAME),
            ],
            error: "lastNameError"
        },
        CONFIRMATION_NUMBER: {
            label: 'confirmationNumber',
            isRequired: true,
            placeholder: 'Please enter your confirmation number',
            required: 'confirmationNumberRequired',
            maxLength: 6,
            validators: [
                Validators.required,
                Validators.pattern(regexPatterns.CONFIRMATION_NUMBER)
            ],
            error: "confirmationError"
        }
    }
};

export const FLIGHT_SEARCH_FORM = {
    FALLBACK: {
        INVALID_ACCEPTANCE_COUNT: 2
    },
    MESSAGES: {
        TITLE: "title",
        INFO: "info",
        INFO_NO_SCAN: 'infoNoScanner',
        ERROR: "easySearchError",
        LINK_TEXT: "linkText",
    },
    CONTROLS: {
        DESTINATION: {
            label: 'destination',
            isRequired: true,
            placeholder: "Please enter your final destination",
            required: 'destinationRequired',
            datListLength: 20,
            searchMinLength: 3,
            maxLength: nameMaxLength,
            validators: [
                Validators.required,
                Validators.pattern(regexPatterns.DESTINATION)
            ],
            error: {
                invalid: "destinationError",
                optionSelect: "destinationNotSelected"
            }
        },
        CURRENT_LOCATION: {
            label: 'location',
            isRequired: true,
            placeholder: "Please enter your current location",
            required: 'locationRequired',
            datListLength: 20,
            searchMinLength: 3,
            maxLength: nameMaxLength,
            validators: [
                Validators.required,
                Validators.pattern(regexPatterns.DESTINATION)
            ],
            error: {
                invalid: "locationError",
                optionSelect: "locationNotSelected"
            }
        },
        LAST_NAME: {
            label: 'lastName',
            isRequired: true,
            placeholder: "Please enter your last name or surname",
            required: 'lastNameRequired',

            maxLength: nameMaxLength,
            validators: [
                Validators.required,
                Validators.pattern(regexPatterns.NAME),
            ],
            error: "lastNameError"
        },
        DATE_OF_BIRTH: {
            label: 'birthDate',
            isRequired: true,
            error: 'dateError',
            placeholder: 'datePlaceholder',
            month: {
                placeholder: "Month",
                validators: [
                    Validators.required
                ],
            },
            day: {
                placeholder: "DD",
                validators: [
                    Validators.required,
                    Validators.pattern(regexPatterns.DAY)
                ],
                maxLength: 2,
                maxValue: 31,
                minValue: 1,
                error: "dayError",
                required: "dayRequired"
            },
            year: {
                placeholder: "YYYY",
                validators: [
                    Validators.required,
                    Validators.pattern(regexPatterns.YEAR),
                    Validators.max(new Date().getFullYear()),
                    Validators.min(1900)
                ],
                maxLength: 4,
                error: "yearError",
                minValue: 1900,
                maxValue: new Date().getFullYear(),
                required: "yearRequired"
            }


        }
    }
};


export const TRAVELER_SELECTION_FORM = {
    MESSAGES: {
        TITLE: "Passenger selection",
        INFO: "Who do we have the pleasure of speaking with today?"
    },
}

export const supportedBrowsers = [
    {
        name: "Chrome",
        minVersion: 56,
    },
    {
        name: "Safari",
        minVersion: 11,
    },
    {
        name: "Firefox",
        minVersion: 44,
    }
]


export enum ALERT_MODES {
    INFO = 'info',
    ERROR = 'error',
    WARNING = 'warning',
    SUCCESS = 'success'
}

export enum ERROR_KEYS {
    NORMAL_TIMEOUT = 'NT',
    NO_AGENTS = 'NA',
    NON_WORKING_HOURS = 'NWH'
}

export const ERROR_MESSAGES = {
    [ERROR_KEYS.NORMAL_TIMEOUT]: 'timeout',
    [ERROR_KEYS.NO_AGENTS]: {
        title: 'noAgentsTitle',
        message: 'noAgentsMessage'
    },
    [ERROR_KEYS.NON_WORKING_HOURS]: {
        title: 'nonWorkHoursTitle',
        message: 'nonWorkHoursMessage'
    },
    COMMON_ERROR: 'commonErr'
};

export const SESSION_ERROR = {
    TITLE: 'sessionErrorMessage'
}

export const UNAVAILABLE_ERROR = {
    TITLE: 'unavailableMessage'
}

export const SESSION_INACTIVITY = {
    IDLE_PERIOD: 30,
    TIMEOUT_PERIOD: 15
};

export const CONTACT = {
    TRANSFER: "transfer",
    CALL_NUMBER: "callNumber"
}

export const API = {
    ERROR_CODES: {
        UNAUTHORIZED: 511,
        TEAPOT: 418
    },
    BOARDING_PASS: 'boardingpass',
    PNR_SEARCH: 'pnr',
    AUTH: 'auth',
    LANGUAGE: 'language',
    ROUTING_SEARCH: 'routing',
    FLIGHT: 'flight',
    AIRPORTS: 'airport',
    HELP_OPTIONS: 'help-options',
    QUEUE: 'queue',
    FEEDBACK: 'feedback',
    UPSERT_FEEDBACK: 'upsert-feedback',
    WEBEX: 'webex',
    UPSERT_CHAT_REQUEST: 'upsert-chat-request',
    UPSERT_TRH_NAV_REQUEST: 'upsert-trh-nav-request',
    UPSERT_DATADOG: 'upsert-datadog',
}

//export const PAYMENT_NOTIFICATION_MESSAGE = "Agent on Demand only accepts payments from authorized credit cards added to your MileagePlus account.";
export const PAYMENT_NOTIFICATION_MESSAGE = "paymentInfo";

export const LOCALE_ID = 'en-US';

// export const UA_SOURCE_CODES = [

//   "customer-mobile", // customer facing mobile
//   "aod-web", // united.fiveout.app AOD web application
//   "self-service-kiosk", // self service kiosk
//   "baggage-service", // baggage management application
//   "dot-com" // UAVA-1010
// ]

export const UA_SOURCE_CODES = {
    customerMobile: 'customer-mobile',
    customerMobileTRH: 'customer-mobile-TRH',
    aodWeb: 'aod-web',
    kiosk: 'self-service-kiosk',
    baggageService: 'baggage-service',
    dotCom: 'dotcom',
    baggage: 'Baggage',
    dotComTRH: 'dotcom-TRH',
}

export const LOADER_TEXT = {
    PNR: 'pnr',
    BOARDINGPASS: 'boardingPass',
    FLIGHT: 'pnr',
    "HELP-OPTIONS": 'loading',
    LOADING: '',
}
export const PARAM_REASONS = {
    ALL: [
        HELP_OPTION_CODES.FLIGHT_CHANGE,
        HELP_OPTION_CODES.FLIGHT_REBOOK,
        HELP_OPTION_CODES.SEAT_CHANGE,
        HELP_OPTION_CODES.OTHER,
        HELP_OPTION_CODES.DOC_CHECK,
        HELP_OPTION_CODES.BAGGAGE
    ],
    CANCEL: [
        HELP_OPTION_CODES.FLIGHT_REBOOK,
        HELP_OPTION_CODES.DOC_CHECK,
        HELP_OPTION_CODES.OTHER,
    ],
    PRIMARY: [
        HELP_OPTION_CODES.DOC_CHECK,
        HELP_OPTION_CODES.FLIGHT_CHANGE,
        HELP_OPTION_CODES.SEAT_CHANGE,
        HELP_OPTION_CODES.OTHER
    ],
    DOC_CHECK: [
        HELP_OPTION_CODES.DOC_CHECK,
        HELP_OPTION_CODES.OTHER
    ],
    BOARDING_PASS: [
        HELP_OPTION_CODES.FLIGHT_CHANGE,
        HELP_OPTION_CODES.SEAT_CHANGE,
        HELP_OPTION_CODES.BOARDING_PASS,
        HELP_OPTION_CODES.OTHER
    ],
    BAGGAGE: [
        HELP_OPTION_CODES.BAGGAGE,
        HELP_OPTION_CODES.OTHER
    ],
    HAWAII: [
        HELP_OPTION_CODES.DOC_CHECK,
        HELP_OPTION_CODES.OTHER
    ],

};

export const CHAT_CONSTANTS = {
    THANK_YOU: "thankYou",
    CONNECT: "connectText",
    CONNECTED: "connectedText",
    LOAD: "loader",
    NEW_SESSION: "newSession"
}

export const APP_POLICIES = {
    cookiePolicy: "https://www.united.com/ual/en/us/fly/cookie-policy.html",
    smsPolicy: "https://united.com/texts",
    united: "https://www.united.com/",
}

export const TRH_UNITED_URL = {
    PRD: 'https://www.united.com/en/us/checkin/e',
    QA: 'https://qa9.united.com/en/us/checkin/e'
}

export const ACCESS_DENIED_CONSTANTS = {
    ACCESS_DENIED: 'noAccess',
    UNAVAILABLE: 'unavailable',
    HELPER: 'helper'
}

export enum OS_NAME {
    ios = "iOS",
    android = "Android"
}

export const supportedOS = {
    all: [OS_NAME.ios, OS_NAME.android],
    ios: OS_NAME.ios,
    android: OS_NAME.android
};

export const AUTO_MESSAGE = {
    DEFAULT: 'default',
    TEST: 'test',
    DOC_CHECK: 'docCheck',
    HAWAII: 'hawaiiPreClearance',
}

// UAVA-1618
export const SPL_DESTINATIONS = {
    HAWAII: 'HNL',
    HILO: 'ITO',
    KAHULUI: 'OGG',
    KEAHOLE: 'KOA',
    LIHUE: 'LIH',
}

// UAVA-1234
export enum BAG_STATUS {
    ARRIVED = 'Arrived',
    DELAYED = 'Delayed',
    EARLY = 'Arrived Early',
    CAROUSEL = 'Carousel'
}

export const SEND_BP_FORM = {
    CONTROLS: {
        EMAIL: {
            label: 'email',
            placeholder: "Email",
            validators: [
                Validators.pattern(regexPatterns.EMAIL)
            ],
            errors: {
                required: 'requiredEmailError',
                invalid: "invalidEmailError",
            }
        },
        PHONE: {

            validators: [],
            controls: {
                CODE: {
                    label: 'countryCode',
                    placeholder: 'countryCodePlaceHolder',
                    validators: [],
                    options: []
                },
                NUMBER: {
                    label: 'phone',
                    placeholder: 'XXX - XXX - XXXX',
                    validators: {
                        default: [],
                        others: [
                            Validators.pattern(regexPatterns.PHONE_NUMBER)
                        ]
                    },
                    maskOptions: {
                        mask: [/[2-9]/, /\d/, /\d/, ' ', '-', ' ', /\d/, /\d/, /\d/, ' ', '-', ' ', /\d/, /\d/, /\d/, /\d/],
                        guide: false
                    },
                    errors: {
                        required: 'phoneRequired',
                        invalid: 'invalidPhone'
                    }
                },
            }
        },
    }
}
export const MAX_CALLOUT_RETRIES = 2;

export const WeekDay = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

/** ---------------- UNUSED -----------**/

// export const HELP_OPTIONS = {
//     TITLE: "formTitle",
//     PRIMARY: [
//         {
//             label: "verifyTravelDocs",
//             value: HELP_OPTION_CODES.DOC_CHECK,
//             icon: "doc-check.svg"
//         },
//         {
//             label: "flightChange",
//             value: HELP_OPTION_CODES.FLIGHT_CHANGE,
//             icon: "flight-icon.svg",
//         },
//         {
//             label: "seatChange",
//             value: HELP_OPTION_CODES.SEAT_CHANGE,
//             icon: "seat.svg",
//         },
//         {
//             label: "bag",
//             value: HELP_OPTION_CODES.BAGGAGE,
//             icon: "baggage.png",
//         },
//     ],
//     BOARDING_PASS: [
//         {
//             label: "boardingPass",
//             value: HELP_OPTION_CODES.BOARDING_PASS,
//             icon: "boarding-pass-white.svg",
//             styleClass: 'primary'
//         },
//         {
//             label: "flightChange",
//             value: HELP_OPTION_CODES.FLIGHT_CHANGE,
//             icon: "flight-icon.svg",
//         },
//         {
//             label: "seatChange",
//             value: HELP_OPTION_CODES.SEAT_CHANGE,
//             icon: "seat.svg",
//         },
//         {
//             label: "bag",
//             value: HELP_OPTION_CODES.BAGGAGE,
//             icon: "baggage.png",
//         },
//     ],
//     DOC_CHECK: [
//         {
//             label: "verifyTravelDocs",
//             value: HELP_OPTION_CODES.DOC_CHECK,
//             icon: "doc-check-white.svg",
//             styleClass: 'primary'
//         },
//     ],
//     CANCEL: [
//         {
//             label: "rebook",
//             value: HELP_OPTION_CODES.FLIGHT_REBOOK,
//             icon: "rebook.svg", // Todo: Icon needs to be changed
//             styleClass: 'primary'
//         },
//         {
//             label: "verifyTravelDocs",
//             value: HELP_OPTION_CODES.DOC_CHECK,
//             icon: "doc-check.svg"
//         },
//         {
//             label: "bag",
//             value: HELP_OPTION_CODES.BAGGAGE,
//             icon: "baggage.png",
//         },
//     ],
//     BAGGAGE: [
//         {
//             label: "bag",
//             value: HELP_OPTION_CODES.BAGGAGE,
//             icon: "baggage.png",
//         }
//     ],
//     SECONDARY: {
//         display: true,
//         label: "other",
//         value: HELP_OPTION_CODES.OTHER,
//     },
//     PRE_CHAT_REASONS: {
//         DEFAULT: [
//             {
//                 label: "flightChange",
//                 value: HELP_OPTION_CODES.FLIGHT_CHANGE
//             },
//             {
//                 label: "seatChange",
//                 value: HELP_OPTION_CODES.SEAT_CHANGE
//             },
//             {
//                 label: "verifyTravelDocs",
//                 value: HELP_OPTION_CODES.DOC_CHECK
//             },
//             {
//                 label: "baggage",
//                 value: HELP_OPTION_CODES.BAGGAGE
//             },
//             {
//                 label: "somethingElse",
//                 value: HELP_OPTION_CODES.OTHER
//             },
//         ],
//         DOC_CHECK: [
//             {
//                 label: "verifyTravelDocs",
//                 value: HELP_OPTION_CODES.DOC_CHECK
//             },
//             {
//                 label: "somethingElse",
//                 value: HELP_OPTION_CODES.OTHER
//             },
//         ],
//         BAGGAGE: [
//             {
//                 label: "bag",
//                 value: HELP_OPTION_CODES.BAGGAGE,
//                 icon: "baggage.png",
//             },
//             {
//                 label: "somethingElse",
//                 value: HELP_OPTION_CODES.OTHER
//             }
//         ],
//         HAWAII: [
//                 {
//                     label: "hawaiiPreClearance",
//                     value: HELP_OPTION_CODES.DOC_CHECK, //TODO: convert to pre clearance
//                 },
//                 {
//                     label: "somethingElse",
//                     value: HELP_OPTION_CODES.OTHER
//                 }
//         ],
//     },
//     HAWAII: {
//         DEFAULT: [
//             {
//                 label: "hawaiiPreClearance",
//                 value: HELP_OPTION_CODES.DOC_CHECK, //TODO: convert to pre clearance
//                 icon: "vacation-white.svg",
//                 styleClass: 'primary'
//             },          
//         ],
//         CHECKED_IN: [
//             {
//                 label: "hawaiiPreClearance",
//                 value: HELP_OPTION_CODES.DOC_CHECK, //TODO: convert to pre clearance
//                 icon: "vacation.svg",
//                 styleClass: 'primary'
//             },      
//             {
//                 label: "boardingPass",
//                 value: HELP_OPTION_CODES.BOARDING_PASS,
//                 icon: "boarding-pass.svg",
//             }, 
//         ],
//         CANCEL: [
//             {
//                 label: "rebook",
//                 value: HELP_OPTION_CODES.FLIGHT_REBOOK,
//                 icon: "rebook.svg", // Todo: Icon needs to be changed
//                 styleClass: 'primary'
//             },
//         ]
//     },
//     ERROR_MESSAGES: {
//         BOARDING_PASS: "boardingPassError"
//     }
// }

export enum FLIGHT_STATUS {
    ARRIVED_AT_GATE = 'ARRIVED_AT_GATE',
    LANDED = 'LANDED',
    NOT_DEPARTED = 'NOT_DEPARTED',
    CANCEL = 'CANCEL',
    RETURNED_TO_GATE = 'RETURNED_TO_GATE',
    DEPARTED_GATE = 'DEPARTED_GATE',
    RETURNED_TO_AIRPORT = 'RETURNED_TO_AIRPORT'
}

export enum API_PATHS {
    DISCOVERY_URI = "/oauth2/v1/.well-known/openid-configuration",
    PNR_URI = "/v1.0/api/aod/search/pnr",
    EASY_SEARCH_URI = "/v1.0/api/aod/easy/search/bydob",
    ROUTING_URI = "/v1.0/api/aod/search/routing",
    BP_URI = "/v1.0/api/aod/search/boardingpass",
    ASSET_ID_URI = "/v1.0/api/aod/asset/get",
    SHOPPING_SERVICE_URI = "/v1.0/api/aod/flight/rebook/shoppingservice",
    CHANGE_SEGMENT_URI = "/v1.0/api/aod/flight/rebook/change/segment"
}

export const EXTERNAL_API = {
    STAGE: {
        GET_SKILL_STATUS: 'https://uw-ual-q2q-lab-vip.united.upstreamworkssoftware.com/PublicAPIs/api/GetSkillStatus',
        GET_HEALTH_STATUS: 'https://um-lab.united.upstreamworkssoftware.com/health',
        CALL_CENTER: 'https://uw-ual-q2q-lab-vip.united.upstreamworkssoftware.com',
    },
    QA: {
        GET_SKILL_STATUS: 'https://uw-ual-q2q-lab-vip.united.upstreamworkssoftware.com/PublicAPIs/api/GetSkillStatus',
        GET_HEALTH_STATUS: 'https://um-lab.united.upstreamworkssoftware.com/health',
        CALL_CENTER: 'https://uw-ual-q2q-lab-vip.united.upstreamworkssoftware.com',
    },
    PROD: {
        GET_SKILL_STATUS: 'https://uw-ual-q2q-lab-vip.united.upstreamworkssoftware.com/PublicAPIs/api/GetSkillStatus',
        GET_HEALTH_STATUS: 'https://um-lab.united.upstreamworkssoftware.com/health',
        CALL_CENTER: 'https://uw-ual-q2q-lab-vip.united.upstreamworkssoftware.com',
    }
}